import React from "react";
import { Subheading } from "../Subheading/Subheading";

type AboutCardProps = {
  img: string;
  imgText: string;
  description: string;
  fontIndex?: number[];
  isOdd: boolean;
};

export const AboutCard: React.FC<AboutCardProps> = ({
  img,
  imgText,
  description,
  fontIndex,
  isOdd,
}) => {
  return (
    <div>
      {/* Mobile/Tablet Layout */}
      <div
        className="block lg:hidden h-screen w-screen relative"
        style={{
          backgroundImage: `url(${img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* imgText at top right/left (isOdd logic swapped) */}
        <img
          src={imgText}
          alt="text"
          className={`
            absolute top-6
            ${!isOdd ? "left-6" : "right-6"}
            w-[80vw] max-w-none
          `}
        />
        {/* Subheading at bottom left/right (isOdd logic swapped) */}
        <div
          className={`
            absolute bottom-6
            ${!isOdd ? "right-6" : "left-6"}
            w-3/4
            flex justify-end
          `}
        >
          <Subheading
            placeholder={description}
            size="md"
            className="text-right font-gilroy-black"
            justify={!isOdd ? "end" : "start"}
            fontIndex={fontIndex}
          />
        </div>
      </div>
      {/* Desktop Layout */}
      <div
        className={`hidden lg:flex h-screen w-screen justify-center items-center px-20 relative`}
      >
        <img
          src={imgText}
          alt="text"
          className={`absolute translate-y-2/5 bottom-0 ${isOdd ? "right-0" : "left-0"}`}
        />
        <div
          className={`w-full h-4/5 flex justify-between items-center ${isOdd ? "flex-row-reverse" : ""}`}
        >
          <img
            src={img}
            alt="image"
            className="h-full object-contain object-center rounded-2xl"
          />
          <div className="w-1/3 flex justify-center items-center">
            <Subheading
              placeholder={description}
              size="md"
              className="text-center font-gilroy-black"
              justify={isOdd ? "start" : "end"}
              fontIndex={fontIndex}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
